import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Order from './pages/order';
import AppBar from './components/appBar';
import { Toaster } from 'react-hot-toast';
import Status from './pages/status';
import Success from './pages/success';
import Manage from './pages/manage';

function App() {

  return (
    <BrowserRouter>
      <AppBar />
      <Toaster />
      <Routes>
        <Route path='/' element={<Order />} />
        <Route path='/status' element={<Status />} />
        <Route path='/success' element={<Success />} />
        <Route path='/manage' element={<Manage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
